import { Stack, Typography } from "@mui/material";

import { useTranslation } from "@/translations";

export function Statistics() {
  const { t } = useTranslation();

  return (
    <Stack spacing={3} flex={1} overflow={"hidden"}>
      <Typography variant="h1">{t("layout.navigation.statistics")}</Typography>
    </Stack>
  );
}
